import React from 'react';
import { protectedRoute } from '@/modules/core/root/protected/route';
import { createRoute } from '@tanstack/react-router';

export const analyticsRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'analytics',
  component: React.lazy(async () => await import('@/app/routes/Analytics')),
  wrapInSuspense: true,
});
